import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, useHistory, useLocation } from 'react-router-dom';

import type { DepartmentId } from '@vlabs/api/artemy/model';

interface DepartmentLocationState {
  departmentId?: DepartmentId;
}

function useGoToDepartment(): {
  currentDepartmentId?: DepartmentId;
  goToDepartment: (departmentId?: DepartmentId) => void;
} {
  const history = useHistory();
  const location = useLocation<DepartmentLocationState | undefined>();
  const queryParams = new URLSearchParams(location.search);
  const currentDepartmentId = queryParams.get('departmentId') ?? location.state?.departmentId;

  const goToDepartment = (departmentId?: DepartmentId): void => {
    if (departmentId) {
      queryParams.set('departmentId', departmentId);
    } else {
      queryParams.delete('departmentId');
    }

    history.push({
      pathname: generatePath(routes.departments.list),
      search: queryParams.toString(),
      state: undefined,
    });
  };

  return { currentDepartmentId, goToDepartment };
}

export { useGoToDepartment };
